module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm",
    attrs: {
      "id": "fm"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_vm._v("Leading Characters")])]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("The Barak (Berkowitz) family")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Z"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARAK")]), _vm._v(", born in Vienna, name Hebraized from Wolfgang Berkowitz. Army field officer, military emissary to America, later military attaché in Washington")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Nakhama, his wife")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Noah, his son")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Galia, his daughter")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Ruti, his daughter")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Meyer Berkowitz, his father, in the foreign service")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Michael Berkowitz, his religious brother, a scientist")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Lena Berkowitz, Michael’s irreligious wife")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Reuven, Lena and Michael’s infant son")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("The Pasternak family")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AM")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTERNAK")]), _vm._v(", born in Czechoslovakia. Kibbutznik, combat officer, later in military procurement and the Mossad")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Amos, his son")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Ruth, his estranged wife")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('em', [_vm._v("The Luria family")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENNY")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URIA")]), _vm._v(", Sabra, born in Moshe Dayan’s moshav. Air force pilot")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Irit, his wife")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Yael, his sister, later Yossi Nitzan’s wife")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Daphna, his daughter")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Dov, his son")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Danny, his son")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("The Nitzan (Blumenthal) family")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSSI")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITZAN")]), _vm._v(", combat officer, born Joseph Blumenthal in Poland (nickname Don Kishote)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Leopold, his brother (emigrates from Israel to America, changes name to Lee Bloom)")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Shayna Matisdorf, Yossi’s first love")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Aryeh, son of Yossi and Yael (Luria)")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("The Cunningham family (American)")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRISTIAN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNNINGHAM")]), _vm._v(", a CIA officer")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Emily, his daughter")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent1"
  }, [_vm._v("Bradford Halliday, army officer, Emily’s suitor")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e295ed68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/9780795344114_epub_fm_r1.vue
// module id = 69
// module chunks = 0